import { render, staticRenderFns } from "./fiyatbilgileri.vue?vue&type=template&id=59561282"
import script from "./fiyatbilgileri.vue?vue&type=script&lang=js"
export * from "./fiyatbilgileri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports